import { MAIN_ACTION } from '../../constants/actions'
import { CLAIM_CURRENCY_TYPE } from '../../constants/app'
import { isCustomVestingFlow } from '../../util/app.helpers'
import { formatAmount } from '../../util/numbers.helpers'
import { mergeToNewObject } from '../../util/object.helpers'
import { buildTransactionErrorMessage } from '../../util/walletConnect.helpers'

const mainReducer = (state, { type, payload }) => {
  switch (type) {
    case MAIN_ACTION.CHANGE_STATE:
      return mergeToNewObject(
        state,
        { [payload.property]: payload.value },
        handleChangeState(payload)
      )

    case MAIN_ACTION.RESET_STATE:
      return mergeToNewObject(state, {
        loading: false,
        claimQBXProcessing: false,
        claimStakeProcessing: false,
        claimStakeProcessing2: false,
        claimTapProcessing: false,
        claimTapType: '',
        qbxTxnPayload: null,
        claimedVir: null,
        contractsForClaim: state.contractsForClaim,
        error: {}
      })

    case MAIN_ACTION.GET_STAKING_DATA:
      return mergeToNewObject(state, {
        claimStake2: {
          ...state.claimStake2,
          loading: true
        }
      })

    case MAIN_ACTION.GET_STAKING_DATA_SUCCESS:
      const { releaseable } = payload
      return mergeToNewObject(state, {
        claimStake2: {
          ...state.claimStake2,
          loading: false,
          available: formatAmount(releaseable) // @TODO: Cross check and confirm whether this is wei or normal format
        }
      })

    case MAIN_ACTION.GET_STAKING_DATA_FAILED:
      return mergeToNewObject(state, {
        claimStake2: {
          ...state.claimStake2,
          loading: false
        }
      })

    case MAIN_ACTION.CLAIM_STAKING:
      return mergeToNewObject(state, {
        claimStakeProcessing2: true,
        qbxTxnPayload: null,
        error: {}
      })

    case MAIN_ACTION.CLAIM_STAKING_SUCCESS:
      return mergeToNewObject(state, {
        claimStakeProcessing2: false,
        qbxTxnPayload: payload,
        error: {}
      })

    case MAIN_ACTION.CLAIM_STAKING_FAILED:
      return mergeToNewObject(state, {
        claimStakeProcessing2: false,
        qbxTxnPayload: null,
        error: {
          claimStake2: buildTransactionErrorMessage()
        }
      })

    case MAIN_ACTION.CLAIM_TAP:
      return mergeToNewObject(state, {
        claimTapProcessing: true,
        claimedVir: null,
        claimTapType: payload.type
      })

    case MAIN_ACTION.CLAIM_TAP_SUCCESS:
      const isTypeVir = state.claimTapType === CLAIM_CURRENCY_TYPE.VIR
      const contractsForClaim = state.contractsForClaim.map((record) =>
        isCustomVestingFlow(record.id)
          ? {
              ...record,
              ...(isTypeVir ? { available: 0 } : {}),
              choice: state.claimTapType
            }
          : record
      )
      return mergeToNewObject(
        state,
        {
          claimTapProcessing: false,
          error: {},
          contractsForClaim
        },
        isTypeVir
          ? {
              claimedVir: payload,
              qbxTxnPayload: null
            }
          : {
              claimedVir: null,
              qbxTxnPayload: payload
            }
      )

    case MAIN_ACTION.CLAIM_TAP_FAILED:
      return mergeToNewObject(state, {
        claimTapProcessing: false,
        claimedVir: null,
        qbxTxnPayload: null,
        error: {
          claimTap: buildTransactionErrorMessage()
        }
      })

    default:
      return state
  }
}

const mainInitialState = {
  loading: false,
  claimQBXProcessing: false,
  claimStakeProcessing: false,
  claimStakeProcessing2: false,
  claimTapProcessing: false,
  claimTapType: '',
  contractsForClaim: [],
  claimedVir: null,
  qbxTxnPayload: null,
  error: {},
  claimStake: {
    available: 0,
    loading: false
  },
  claimStake2: {
    available: 0,
    loading: false
  }
}

const MAIN_PROFILE_DISPATCH = {
  LOADING: 'loading',
  CLAIM_QBX_PROCESSING: 'claimQBXProcessing',
  CLAIM_STAKE_PROCESSING: 'claimStakeProcessing',
  CLAIM_STAKE_PROCESSING2: 'claimStakeProcessing2',
  CLAIM_TAP_PROCESSING: 'claimTapProcessing',
  CONTRACTS_TO_CLAIM: 'contractsForClaim',
  CLAIM_STAKE: 'claimStake',
  CLAIM_STAKE2: 'claimStake2',
  CLAIM_QBX: 'claimQBX',
  ERROR: 'error',
  CLAIM_TAP: 'claimTap',
  QBX_TXN_PAYLOAD: 'qbxTxnPayload',
  CLAIMED_VIR: 'claimedVir'
}

export { mainReducer, mainInitialState, MAIN_PROFILE_DISPATCH }

const handleChangeState = ({ property }) => {
  if (property === MAIN_PROFILE_DISPATCH.ERROR) {
    return {
      claimQBXProcessing: false,
      claimStakeProcessing: false,
      claimStakeProcessing2: false,
      claimTapProcessing: false
    }
  } else if (
    [
      MAIN_PROFILE_DISPATCH.CLAIM_QBX_PROCESSING,
      MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING,
      MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING2,
      MAIN_PROFILE_DISPATCH.CLAIM_TAP_PROCESSING
    ].includes(property)
  ) {
    return {
      error: {}
    }
  }
  return {}
}
